import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

// Angka polos tanpa titik/Rp agar langsung bisa ditempel di kolom Coretax
export const plainNumber = (v) => String(Math.round(Number(v) || 0));

export function CopyValue({ value, label, testid, raw = false }) {
  const [done, setDone] = useState(false);
  const text = raw ? String(value ?? "") : plainNumber(value);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const t = document.createElement("textarea");
      t.value = text; document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove();
    }
    setDone(true); toast.success(`${label || "Angka"} disalin: ${text}`);
    setTimeout(() => setDone(false), 1500);
  };
  return (
    <button type="button" onClick={copy} title="Salin" data-testid={testid}
      className="inline-flex items-center gap-1 rounded-md border border-slate-200 px-2 py-1 text-[11px] font-medium text-slate-600 hover:bg-slate-100 transition-colors">
      {done ? <Check size={12} className="text-emerald-600"/> : <Copy size={12}/>} Salin
    </button>
  );
}
